import { CircularProgress, Divider, Typography } from "@suraasa/placebo-ui"
import { theme, useMediaQuery } from "@suraasa/placebo-ui-legacy"
import NotificationBell from "assets/Fallback/notification-bell.svg"
import clsx from "clsx"
import Fallback from "components/Fallback"
import PageContainer from "components/PageContainer"
import { useEffect } from "react"
import { isShadow } from "utils/shadow"

import TabBar from "../../components/TabBar"
import { useNotifications } from "./hooks/useNotifications"
import styles from "./Notifications.module.css"
import NotificationsList from "./NotificationsList"

const Notifications = () => {
  const {
    tabs,
    notifications,
    activeTab,
    changeTab,
    markAllAsRead,
    pageOverview,
    getDescription,
  } = useNotifications()

  const { isLoading: pageLoading, isError: pageError } = pageOverview

  useEffect(() => {
    if (!isShadow()) markAllAsRead()
  }, [])

  const {
    data: notificationList,
    isFetching,
    isError,
    hasNextPage,
    fetchNextPage,
  } = notifications

  const xsDown = useMediaQuery(theme.breakpoints.down("xs"))
  const mdUp = useMediaQuery(theme.breakpoints.up("md"))

  if (pageLoading || pageError) {
    return (
      <Fallback
        data={{
          image: NotificationBell,
          title: "No Notifications!",
        }}
        isLoading={pageLoading}
        hasError={pageError}
      />
    )
  }

  return (
    <div>
      <div className="bg-white">
        <PageContainer
          fullWidth={xsDown}
          className={clsx({
            [styles.topBar]: mdUp,
          })}
        >
          <div className="px-2 sm:px-0">
            <div className="my-2">
              <Typography variant="title2">Notifications</Typography>
            </div>
          </div>
          <div
            className={clsx({
              [styles.notificationTabBar]: xsDown,
            })}
          >
            <TabBar
              className="pt-1"
              activeTab={activeTab}
              tabs={tabs}
              onChange={changeTab}
            />
          </div>
        </PageContainer>
      </div>
      <Divider className={clsx(styles.divider)} />
      <PageContainer fullWidth={xsDown} className="pb-8 md:pb-2">
        <div className="flex flex-col">
          {(isError ||
            notificationList?.pages[0].data.notifications.length == 0) && (
            <Fallback
              data={{
                image: NotificationBell,
                title: "No Notifications!",
                description: getDescription(),
              }}
              className="fixed left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 px-2 text-center sm:w-fit sm:px-0"
              hasError={isError}
            />
          )}

          {notificationList && (
            <NotificationsList
              data={notificationList}
              loading={isFetching}
              hasNextPage={hasNextPage}
              actionFunc={fetchNextPage}
            />
          )}

          {isFetching && (
            <div className="flex flex-col items-center py-5">
              <CircularProgress />
            </div>
          )}
        </div>
      </PageContainer>
    </div>
  )
}

export default Notifications
